export default __webpack_public_path__ + "static/media/phone.e542ecf6.svg";